<template>
	<div class="db">
		<div class="loading">
			<span></span>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'loading',
		components: {},
		data() {
			return {};
		},
		methods: {}
	}
</script>
<style lang="scss" scoped>
	.db {
		position: fixed;
		background: white;
		height: 100%;
		width: 100%;
		top: 0;
		transition-delay: 1s;
		display: -none;
		z-index: 12;
	}

	.loading {
		width: 150px;
		height: 4px;
		border-radius: 2px;
		margin: 0 auto;
		margin-top:45vh;
		position: relative;
		background: lightgreen;
		-webkit-animation: changeBgColor 1.04s ease-in infinite alternate;
	}

	.loading span {
		display: inline-block;
		width: 16px;
		height: 16px;
		border-radius: 50%;
		background: lightgreen;
		position: absolute;
		margin-top: -7px;
		margin-left: -8px;
		-webkit-animation: changePosition 1.04s ease-in infinite alternate;
	}

	@-webkit-keyframes changeBgColor {
		0% {
			background: lightgreen;
		}

		100% {
			background: lightblue;
		}
	}

	@-webkit-keyframes changePosition {
		0% {
			background: lightgreen;
		}

		100% {
			margin-left: 142px;
			background: lightblue;
		}
	}
</style>
